
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePwdComponent } from './changepwd.component';
import { CollaboComponent } from './collabo.component';


import { HeaderComponent } from './header.component';
import { MessageComponent } from './message.component';
import { MyaccountComponent } from './myaccount.component';
import { OverviewComponent } from './overview.component';
import { PaymentComponent } from './payment.component';
import { PostcollaboComponent } from './postcollabo.component';
import { QuotationComponent } from './quotation.component';

// const routes: Routes = [
//     {
//           path: 'collabo', // child route path
//           component: CollaboComponent, // child route component that the router renders
//           data: {
//             title: 'collabo'
//           },
//         },
        
//         {
//           path: 'changepwd',
//           component: ChangePwdComponent, // another child route component that the router renders
//           data: {
//             title: 'changepwd'
//           },
//         },
//         // {
//         //     path: 'message',
//         //     component: MessageComponent, // another child route component that the router renders
//         //   },
//           {
//               path:'overview',
//               component:OverviewComponent,
//           },
//           {path:'postcollabo', component: PostcollaboComponent},
//           {path:'quote', component: QuotationComponent},
//           {path:'payment', component: PaymentComponent},
//           {path:'myaccount', component: MyaccountComponent},
//           // {path:'initatormyaccount', component: MyaccountComponent},
       
//   ];
  
// const routes: Routes = [
//      {path:'header', component: HeaderComponent},
//      {path:'changepwd', component: ChangePwdComponent},
//      {path:'collabo', component: CollaboComponent},
//      {path:'postcollabo', component: PostcollaboComponent},
//      {path:'quote', component: QuotationComponent},
//      {path:'message', component: MessageComponent},
//      {path:'overview', component: OverviewComponent},
//      {path:'payment', component: PaymentComponent},
//      {path:'myaccount', component: MyaccountComponent}
// ];

@NgModule({
})
export class CollaboRoutingModule {}
